import type { FC } from 'react'
import classNames from 'classnames'

import { Text } from 'components'

import styles from './ComingSoonPage.module.scss'

type TComingSoonPageProps = {
  image: string
  title: string
}

const ComingSoonPage: FC<TComingSoonPageProps> = ({ image, title }) => (
  <section className={styles.wrapper} style={{ backgroundImage: `url(${image})` }}>
    <div className={styles.overlay} />
    <div className={classNames('container', styles.inner)}>
      <span className={styles.accent} aria-hidden />
      <Text text={title} className={styles.eyebrow} />
      <Text text='comingSoon' className={styles.title} tagName='h1' />
      <Text text='comingSoonText' className={styles.subtitle} />
    </div>
  </section>
)

export default ComingSoonPage
